import type { CSSProperties } from 'react';
import { Body, Eyebrow, Headline, Img, Qr, Wordmark, arch, frame, sans, serif, type DesignProps } from './designParts';

/** Print (flyer, poster, visitekaartje, cadeaubon, nazorgkaart) en de nieuwsbriefkop. */

const rule = (color: string): CSSProperties => ({
  borderTop: `1px solid ${color}33`
});
export function FlyerDesign({
  d,
  p,
  w,
  h,
  city,
  contact
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    padding: 48
  }} data-id="element-3132" data-mp="j17mxotg2j39">
      <div style={{
      ...arch(778),
      height: 470,
      flexShrink: 0
    }} data-id="element-3133" data-mp="j325iwh8tz46">
        <Img src={d.image} data-id="element-3134" data-mp="e9h9vb34hh85" />
      </div>
      <div style={{
      marginTop: 40,
      display: 'flex',
      flexDirection: 'column',
      gap: 16
    }} data-id="element-3135" data-mp="e8egmwibv2p2">
        <Eyebrow text={d.eyebrow} p={p} size={20} data-id="element-3136" data-mp="991t09jmtrlf" />
        <Headline d={d} p={p} size={62} data-id="element-3137" data-mp="4d4fsc3o11cv" />
        <Body text={d.body} p={p} size={20} maxWidth="92%" data-id="element-3138" data-mp="49yr2xyy81ho" />
      </div>
      {d.points.length > 0 && <ul style={{
      listStyle: 'none',
      padding: 0,
      margin: '26px 0 0'
    }} data-id="element-3139" data-mp="3vk76z3ji77n3">
          {d.points.map((pt, i) => <li key={i} style={{
        ...rule(p.fg),
        padding: '13px 0',
        fontFamily: sans,
        fontSize: 19,
        color: p.fg,
        display: 'flex',
        gap: 16
      }} data-id="element-3140" data-mp="3jhjrufwecl8n" data-mpi={i}>
              <span style={{
          color: p.accent,
          fontFamily: serif,
          fontSize: 20,
          width: 16
        }} data-id="element-3141" data-mp="3o91s11qlihsk">{i + 1}</span>
              {pt}
            </li>)}
        </ul>}
      <div style={{
      marginTop: 'auto',
      display: 'flex',
      alignItems: 'flex-end',
      gap: 28,
      ...rule(p.fg),
      paddingTop: 24
    }} data-id="element-3142" data-mp="3ehxc9zt3iswo">
        <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 16
      }} data-id="element-3143" data-mp="63ood51iqqau">
          <Wordmark size={28} color={p.fg} city={city} data-id="element-3144" data-mp="b2039u6o7qzx" />
          <div style={{
          fontFamily: sans,
          fontSize: 16,
          lineHeight: 1.5,
          color: p.fg
        }} data-id="element-3145" data-mp="azdvpujs5bhp">
            {contact.map(c => <div key={c} data-id="element-3146" data-mp="1312exs5cznh">{c}</div>)}
          </div>
          {d.cta && <div style={{
          fontFamily: sans,
          fontSize: 18,
          fontWeight: 500,
          color: p.fg
        }} data-id="element-3147" data-mp="15ewb3b3c5tg">{d.cta}</div>}
        </div>
        <Qr url={d.qrUrl} p={p} size={128} data-id="element-3148" data-mp="2ltjf1m9u00m6" />
      </div>
    </div>;
}
export function PosterDesign({
  d,
  p,
  w,
  h,
  city,
  product
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    padding: '64px 64px 56px'
  }} data-id="element-3149" data-mp="saapx5uc7sz9">
      <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
    }} data-id="element-3150" data-mp="nd0r4zl264yr">
        <Eyebrow text={d.eyebrow} p={p} size={22} data-id="element-3151" data-mp="ik7nkf1bt2o9" />
        <Wordmark size={24} color={p.fg} city={city} sub="" data-id="element-3152" data-mp="iiwlcjnj42z9" />
      </div>
      <div style={{
      marginTop: 48
    }} data-id="element-3153" data-mp="dlmv51sbfnad">
        <Headline d={d} p={p} size={148} accentSize={46} data-id="element-3154" data-mp="9kkssc33qv46" />
      </div>
      <div style={{
      ...arch(420),
      background: p.soft,
      width: 420,
      height: 460,
      margin: '44px auto 0',
      padding: 48,
      flexShrink: 0
    }} data-id="element-3155" data-mp="9ihw597g23qh">
        <Img src={product?.image ?? ''} fit="contain" width={900} data-id="element-3156" data-mp="3vrj3vely28op" />
      </div>
      <div style={{
      marginTop: 'auto',
      display: 'flex',
      alignItems: 'flex-end',
      gap: 32,
      ...rule(p.fg),
      paddingTop: 28
    }} data-id="element-3157" data-mp="3vtm40rgt9i75">
        <div style={{
        flex: 1
      }} data-id="element-3158" data-mp="1u0xygbgp2io7">
          <Body text={d.body} p={p} size={24} data-id="element-3159" data-mp="1tz4s6x9zu0gq" />
        </div>
        {d.qrUrl && <div style={{
        textAlign: 'center'
      }} data-id="element-3160" data-mp="1p2ea64emouso">
            <Qr url={d.qrUrl} p={p} size={120} data-id="element-3161" data-mp="1ozidejeioc5t" />
            <div style={{
          fontFamily: sans,
          fontSize: 14,
          color: p.fg,
          marginTop: 8
        }} data-id="element-3162" data-mp="1xhaky1smnz3i">Scan en bekijk</div>
          </div>}
      </div>
    </div>;
}
export function CardDesign({
  d,
  p,
  w,
  h,
  city
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    flexDirection: 'row'
  }} data-id="element-3163" data-mp="26bffowavtuob">
      <div style={{
      width: '42%',
      background: p.soft,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: 28
    }} data-id="element-3164" data-mp="2b8p2e46vzs8g">
        <Wordmark size={26} color={p.fg} city={city} sub="" data-id="element-3165" data-mp="1ilcr4q66f6ug" />
        <div style={{
        fontFamily: serif,
        fontStyle: 'italic',
        fontSize: 15,
        color: p.accent,
        lineHeight: 1.3
      }} data-id="element-3166" data-mp="1njwdgroomknc">
          Eén cliënt tegelijk.
          <br data-id="element-3167" data-mp="1sh60k0olmk80" />
          Volgens mijn werkwijze.
        </div>
      </div>
      <div style={{
      flex: 1,
      padding: '28px 28px 24px',
      display: 'flex',
      flexDirection: 'column'
    }} data-id="element-3168" data-mp="2yyjicumi5wwx">
        <div style={{
        fontFamily: serif,
        fontSize: 26,
        color: p.fg,
        lineHeight: 1.1
      }} data-id="element-3169" data-mp="33wuoovdl9pae">{d.headline}</div>
        <div style={{
        fontFamily: sans,
        fontSize: 12,
        color: p.accent,
        marginTop: 6
      }} data-id="element-3170" data-mp="gqi38h7d77mw">{d.body}</div>
        <div style={{
        marginTop: 'auto',
        display: 'flex',
        alignItems: 'flex-end',
        gap: 12
      }} data-id="element-3171" data-mp="bsgepgr66g41">
          <div style={{
          flex: 1,
          fontFamily: sans,
          fontSize: 11.5,
          lineHeight: 1.6,
          color: p.fg
        }} data-id="element-3172" data-mp="ps7unn18y6ko">
            {d.points.map((pt, i) => <div key={i} data-id="element-3173" data-mp="zoud6563oljj" data-mpi={i}>{pt}</div>)}
          </div>
          <Qr url={d.qrUrl} p={p} size={58} data-id="element-3174" data-mp="zmzvr0u1fbk7" />
        </div>
      </div>
    </div>;
}
export function GiftCardDesign({
  d,
  p,
  w,
  h,
  city
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    padding: 28
  }} data-id="element-3175" data-mp="18g32yre3as6e">
      <div style={{
      flex: 1,
      border: `1px solid ${p.accent}`,
      display: 'flex',
      padding: 40,
      gap: 40
    }} data-id="element-3176" data-mp="18iz56rwz030n">
        <div style={{
        flex: 1.2,
        display: 'flex',
        flexDirection: 'column'
      }} data-id="element-3177" data-mp="1ifbuzepe9wq4">
          <Eyebrow text={d.eyebrow} p={p} size={18} data-id="element-3178" data-mp="1id7tf3eyx9t0" />
          <div style={{
          marginTop: 16
        }} data-id="element-3179" data-mp="1dhabiso23ve4">
            <Headline d={d} p={p} size={110} accentSize={28} data-id="element-3180" data-mp="1de4n7fn94xjg" />
          </div>
          <div style={{
          marginTop: 22
        }} data-id="element-3181" data-mp="1x2kbmv1h2u9h">
            <Body text={d.body} p={p} size={17} data-id="element-3182" data-mp="2213v8oslftyo" />
          </div>
          <div style={{
          marginTop: 'auto'
        }} data-id="element-3183" data-mp="220cdagrx5uqv">
            <Wordmark size={24} color={p.fg} city={city} data-id="element-3184" data-mp="1n4cw8gmu0k9l" />
          </div>
        </div>
        <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        background: p.soft,
        padding: '28px 28px 22px'
      }} data-id="element-3185" data-mp="1s2xzyq1alm2s">
          {d.points.map((pt, i) => <div key={i} style={{
          marginTop: i === 0 ? 0 : 30
        }} data-id="element-3186" data-mp="1ea89a8atjszc" data-mpi={i}>
              <div style={{
            fontFamily: sans,
            fontSize: 14,
            color: p.fg
          }} data-id="element-3187" data-mp="1j3b6cqet1kka">{pt}</div>
              <div style={{
            borderBottom: `1px solid ${p.fg}66`,
            height: 36
          }} data-id="element-3188" data-mp="14dvgdcn3lj5n" />
            </div>)}
          <div style={{
          marginTop: 'auto',
          fontFamily: sans,
          fontSize: 12.5,
          lineHeight: 1.5,
          color: p.fg
        }} data-id="element-3189" data-mp="19bn5y009st6o">{d.cta}</div>
        </div>
      </div>
    </div>;
}
export function AftercareDesign({
  d,
  p,
  w,
  h,
  city
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    padding: '48px 48px 40px'
  }} data-id="element-3190" data-mp="zgd69ixcgxw2">
      <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
    }} data-id="element-3191" data-mp="321plxxmnhzxp">
        <Eyebrow text={d.eyebrow} p={p} size={17} data-id="element-3192" data-mp="2x9fnft7gzrjt" />
        <Wordmark size={20} color={p.fg} city={city} sub="" data-id="element-3193" data-mp="2sb4dzjl37j24" />
      </div>
      <div style={{
      marginTop: 36
    }} data-id="element-3194" data-mp="2sbe7vi996ad3">
        <Headline d={d} p={p} size={56} data-id="element-3195" data-mp="2ncb6q8we8oae" />
      </div>
      <ul style={{
      listStyle: 'none',
      padding: 0,
      margin: '32px 0 0'
    }} data-id="element-3196" data-mp="2ndurocszvnii">
        {d.points.map((pt, i) => <li key={i} style={{
        ...rule(p.fg),
        padding: '14px 0',
        display: 'flex',
        gap: 14,
        alignItems: 'baseline',
        fontFamily: sans,
        fontSize: 17,
        color: p.fg,
        lineHeight: 1.4
      }} data-id="element-3197" data-mp="3kxpdx8fmp3ha" data-mpi={i}>
            <span style={{
          width: 8,
          height: 8,
          borderRadius: 99,
          background: p.accent,
          flexShrink: 0,
          transform: 'translateY(-2px)'
        }} data-id="element-3198" data-mp="3700ve791a8fe" />
            {pt}
          </li>)}
      </ul>
      {d.body && <div style={{
      marginTop: 24,
      background: p.soft,
      padding: '18px 22px',
      borderRadius: 12
    }} data-id="element-3199" data-mp="1vl3rxsc3rgoi">
          <Body text={d.body} p={p} size={16} data-id="element-3200" data-mp="b331vw6y8dwq" />
        </div>}
      {d.cta && <div style={{
      marginTop: 'auto'
    }} data-id="element-3201" data-mp="f4eixdbrbqtb">
          <div style={{
        fontFamily: sans,
        fontSize: 14,
        color: p.fg
      }} data-id="element-3202" data-mp="f57s0ky6usem">{d.cta}</div>
          <div style={{
        borderBottom: `1px solid ${p.fg}66`,
        height: 34
      }} data-id="element-3203" data-mp="k398cy48cdme" />
        </div>}
    </div>;
}
export function EmailDesign({
  d,
  p,
  w,
  h,
  city
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    flexDirection: 'row'
  }} data-id="element-3204" data-mp="ttu7qnrq9m6d">
      <div style={{
      flex: 1.15,
      padding: '56px 64px',
      display: 'flex',
      flexDirection: 'column'
    }} data-id="element-3205" data-mp="tvndm0uio2db">
        <Wordmark size={26} color={p.fg} city={city} sub="" data-id="element-3206" data-mp="yu8fe4pf2u3v" />
        <div style={{
        marginTop: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 18
      }} data-id="element-3207" data-mp="12vagkr2w9g8h">
          <Eyebrow text={d.eyebrow} p={p} size={22} data-id="element-3208" data-mp="17rsjrmikt6ip" />
          <Headline d={d} p={p} size={68} data-id="element-3209" data-mp="34ldlumid27vs" />
        </div>
      </div>
      <div style={{
      flex: 1,
      padding: '40px 40px 0 0'
    }} data-id="element-3210" data-mp="34n6q5v5i4g0m">
        <div style={{
        ...arch(520),
        height: '100%'
      }} data-id="element-3211" data-mp="39jnhey7zzahx">
          <Img src={d.image} data-id="element-3212" data-mp="39m9wdix7wsa6" />
        </div>
      </div>
    </div>;
}